"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Account = function Account(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "transactions",
    viewBox: "0 0 22 22"
  }, rest), react_1["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    transform: "translate(-24.000000, -179.000000)",
    fill: "currentColor"
  }, react_1["default"].createElement("path", {
    d: "M30,188.84 L32.1213203,190.96132 L30.0831458,192.999 L41,193 L41,196 L30.0891458,195.999 L32.1213203,198.032388 L30,200.153708 L24.3431458,194.496854 L30,188.84 Z M35.3431458,179 L41,184.656854 L35.3431458,190.313708 L33.2218254,188.192388 L35.26,186.154708 L24.3431458,186.153708 L24.3431458,183.153708 L35.254,183.154708 L33.2218254,181.12132 L35.3431458,179 Z"
  }))));
};

exports["default"] = Account;